import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed, PropType, ref } from 'vue';
import { useRoute } from 'vue-router';

type Variant = 'link' | 'button';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBarLink',
  props: {
  to: { type: String, required: false, default: undefined },
  icon: { type: String, required: true },
  name: { type: String, required: true },
  collapsed: { type: Boolean, default: false },
  rotate: { type: Boolean, default: false },
  variant: { type: String as PropType<Variant>, default: 'link', required: false },
},
  setup(__props) {

const props = __props;

const route = useRoute();
const isActive = computed(() => {
  if (props.variant === 'button') return false;
  const isDashboard = props.to === '/dashboard';
  return (!isDashboard && route.fullPath.startsWith(props.to ?? '')) ||
    (isDashboard && route.fullPath === props.to);
});

const isHover = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.variant === 'link')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.to,
          class: _normalizeClass(["link flex gap-2 font-semibold cursor-pointer select-none rounded h-8 py-4 no-underline items-center hover:bg-blue-200 hover:border-l-4", {
        active: isActive.value,
        'justify-center': __props.collapsed,
        'pl-2': !__props.collapsed,
      }]),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["shrink-0 opacity-30", {
          [`${__props.icon}`]: true,
          'w-8': !__props.collapsed,
        }])
            }, null, 2),
            (!__props.collapsed)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass({
          'hover:text-blue-700': true,
          'text-blue-700': isActive.value || isHover.value,
          'text-gray-700': !(isActive.value || isHover.value),
        })
                }, _toDisplayString(__props.name), 3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to", "class"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex gap-2 font-semibold cursor-pointer select-none rounded h-8 py-4 no-underline items-center hover:bg-slate-100 border-l-4 border-transparent", {
        'justify-center': __props.collapsed,
        'pl-2': !__props.collapsed,
      }]),
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (isHover.value = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isHover.value = false))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["shrink-0 opacity-30", {
          [`${__props.icon}`]: true,
          'w-8': !__props.collapsed,
          'scale-x-[-1]': __props.rotate && __props.collapsed
        }])
          }, null, 2),
          (!__props.collapsed)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(["hover:text-slate-600 hover:bg-slate-100 text-muted", {
          'text-muted': !isHover.value,
          'text-slate-600': isHover.value
        }])
              }, _toDisplayString(__props.name), 3))
            : _createCommentVNode("", true)
        ], 34))
  ]))
}
}

})